var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"rooof-account-add"}},[_c('rooof-account-form',{staticClass:"form",attrs:{"loading":_vm.loading,"newsletter":true},on:{"submit":_vm.createAccount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }